export default function Contact() {
  return (
    <section id="contact">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="section-title">Contacto</h2>
            <div className="section-title-divider"></div>

            <div className="cta-contact text-center wow zoomIn" data-wow-delay="0.1s">
              <h2 className="cta-title">Monetiza tu Belleza</h2>
              <p className="cta-text">
                Vive la experiencia <span className="text-afrodita-gold font-semibold">Afrodita</span> y alcanza tu máximo potencial.
                <br />
                Multiplica tus <b>ingresos en dólares</b> con pagos diarios y el respaldo de un <b>equipo profesional</b> enfocado en cumplir tus objetivos.
              </p>
            </div>

            <p className="section-description text-center mt-4">
              ¿Tienes preguntas? Estamos aquí para ayudarte a brillar.
            </p>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="info wow fadeInLeft" data-wow-delay="0.1s">
              <div>
                <i className="fa fa-map-marker" />
                <p>
                  <strong>Ubicación:</strong>
                  <br />
                  Colombia - Quindío
                  <br />
                  Centro de Armenia
                  <br />
                  Carrera 14 # 18-33 piso 3
                </p>
              </div>
            </div>

            <div className="info wow fadeInLeft" data-wow-delay="0.3s">
              <div>
                <i className="fa fa-envelope" />
                <p>
                  <strong>Email:</strong>
                  <br />
                  Afroditamodels.axm@gmail.com
                </p>
              </div>
            </div>

            <div className="info wow fadeInLeft" data-wow-delay="0.5s">
              <div>
                <i className="fa fa-phone" />
                <p>
                  <strong>Teléfono:</strong>
                  <br />
                  +57 322 670 7089
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <div className="form wow fadeInUp" data-wow-delay="0.2s">
              <div id="sendmessage">¡Tu mensaje ha sido enviado! Gracias.</div>
              <div id="errormessage"></div>
              <form action="mailto:afroditamodels.axm@gmail.com" method="post">
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    id="name"
                    placeholder="Tu nombre completo"
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Tu correo electrónico"
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Asunto"
                    required
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    placeholder="Escribe tu mensaje aquí..."
                    required
                  ></textarea>
                </div>
                <div className="text-center">
                  <button type="submit">Enviar Mensaje</button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="mapouter w-100 wow fadeInRight" data-wow-delay="0.4s">
              <div className="gmap_canvas w-100">
                <iframe
                  title="map"
                  className="gmap_iframe w-100"
                  scrolling="no"
                  src="https://maps.google.com/maps?width=600&amp;height=450&amp;hl=es&amp;q=Armenia, carrera 14  18-33&amp;t=&amp;z=18&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
